import { getOrganizationSymptoms } from 'api/symptoms';
import { useQuery } from 'react-query';
import QueryKeys from '../queryKeys';
import { OrganizationQueryParams } from 'interfaces/queryParams';
import { IQueryRequest } from 'interfaces/request';

const useOrganizationSymptoms = ({
  params,
  options,
}: IQueryRequest<OrganizationQueryParams>) => {
  return useQuery({
    ...options,
    queryFn: async () => {
      const { data } = await getOrganizationSymptoms(params.organizationId);

      return data.data;
    },
    queryKey: [QueryKeys.getOrganizationSymptoms, params.organizationId],
  });
};

export default useOrganizationSymptoms;
